import React, { useState, useEffect } from 'react';
import { MenueList } from '../components/menues'
//import { s3ListObjects, s3ReadFile, s3WriteFile, s3DeleteFile } from '../components/s3Utils';
import { s3ReadFile, s3ListObjects, s3WriteFile } from '../components/s3Utils';
import { useDispatch } from 'react-redux'
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Button, Offcanvas, Container, Spinner } from 'react-bootstrap';
import { MdSave, MdDoneOutline } from 'react-icons/md'
import reorderSpeiseplan from '../components/lib/reorderSpeiseplan';
import { refillMenueWahlTable } from '../components/lib/getEmptyMenueWahlTable';
import getDateOfNextMonday from '../components/lib/getDateOfNextMonday';
import background from '../components/assets/table-2879213_1920.jpg';
import Footer from '../components/lib/Footer';
import { istMitarbeiter } from '../components/utils';
import { Navigate } from 'react-router-dom';
import StringToDate from "../components/lib/StringToDate";
import { useSelector } from "react-redux";
import { Alert } from '@aws-amplify/ui-react';
import Empfehlung from '../components/lib/Empfehlung';


// import { useBlocker } from "react-router-dom";

// const updateArr = (array, index, val) => {
//     if (index > 14) { index = 14 }
//     const arr = [...array];
//     arr[index] = val;
//     return arr;
// };

function differs(a1, a2) {
    return !(a1.toString() === a2.toString());
}

const Loading = (props) => {
    return (
        <Spinner animation="boarder" role="status">
            <span className="visually-hidden">Loading {props.loadingtext}...</span>
        </Spinner>
    )
}

const Menues = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const dispatch = useDispatch()
    const daten = useSelector(state => state.menueWahl);
    const [menues, setMenues] = useState();
    const [sticky, setSticky] = useState(undefined);
    const [show, setShow] = useState(false);
    const [saved, setSaved] = useState(null);
    const startDatum = user ? istMitarbeiter(user) ? new Date() :
        user['attributes'] && user['attributes']['custom:VON'] ? Math.max(new Date(), StringToDate(user['attributes']['custom:VON'])) : new Date() : new Date();
    // console.log('IstMitarbeiter=:', istMitarbeiter(user), Math.max((new Date()), StringToDate(user['attributes']['custom:VON'])));

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const showFooter = false;


    //    useBlocker("Are you sure you want to leave?", sticky);   // wait for version 6 is completed and useBlocker back

    useEffect(() => {
        window.onbeforeunload = function () {
            if (sticky) {
                return "Sie haben nicht gespeicherte Änderungen?";
            }
        };
    }, [sticky]);

    function handleChange(value) {
        // console.log(daten)
        setSticky(true);
    }

    const storeMenues = (data) => {
        // console.log('storeMenues:', data)
        // console.log('user:', user['attributes']['custom:VON']);
        data.MASPEISEPLAN = reorderSpeiseplan(data.MASPEISEPLAN);
        data.PATSPEISEPLAN = reorderSpeiseplan(data.PATSPEISEPLAN, startDatum);
        dispatch({ type: 'menues/MenuesReplaced', payload: data });
        setMenues(data);

        // console.log('storeReordedMenues:', data)
    }

    const storeMenueWahl = (data, start = startDatum) => {
        const newData = refillMenueWahlTable(data, start);
        // console.log('storeMenueWahl', newData)
        dispatch({ type: 'menueWahl/Replaced', payload: newData });
        // setDaten(newData);
        setSticky(false);
    }

    const handleS3MenueWahl = (result) => {
        // console.log('handleS3MenueWahl result=', result);
        const keys = Object.keys(result);
        if (keys.includes('MenueWahl.txt')) {
            // console.log('keys', keys)
            s3ReadFile('MenueWahl.txt', 'private', storeMenueWahl)
        } else {
            const MenueWahl = {
                User: user.username,
                FirstDate: getDateOfNextMonday(startDatum).toISOString(),
                MenueWahl: Array(14).fill('0'),
                Fruehstueck: Array(14).fill('0'),
                Abendessen: Array(14).fill('0'),
                ToGo: Array(14).fill('0'),
                Sonstiges: Array(14).fill('')
            };
            // console.log('MenueWahl neu befüllen mit', MenueWahl)
            storeMenueWahl(MenueWahl, startDatum);
        }
    }

    const handleSaveButton = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const fruehstueck = Array.from({ length: 14 }, (x, i) => data.get('Frühstück_' + i) === 'on' ? '1' : '0')
        const mittagessen = Array.from({ length: 14 }, (x, i) => data.get('Mittagessen_' + i) === null ? '0' : data.get('Mittagessen_' + i))
        const abendessen = Array.from({ length: 14 }, (x, i) => data.get('Abendessen_' + i) === 'on' ? '1' : '0')
        const togo = Array.from({ length: 14 }, (x, i) => data.get('To Go_' + i) === 'on' && data.get('Mittagessen_' + i) !== null && data.get('Mittagessen_' + i) !== '0' ? '1' : '0')
        const sonstiges = Array.from({ length: 14 }, (x, i) => data.get('Sonstiges_' + i) === null ? '' : data.get('Sonstiges_' + i))
        // console.log('mittagessen, ToGo', mittagessen, togo)

        if (differs(mittagessen, daten.MenueWahl.map(e => e.WAHL)) ||
            differs(fruehstueck, daten.Fruehstueck.map(e => e.WAHL)) ||
            differs(abendessen, daten.Abendessen.map(e => e.WAHL)) ||
            differs(togo, daten.ToGo.map(e => e.WAHL)) ||
            differs(sonstiges, daten.Sonstiges.map(e => e.WAHL))) {
            // console.log('handleSaveButton: different', daten, savedDaten)
            // console.log(user)
            // console.log("differs?", daten.MenueWahl.map(e => e.WAHL), mittagessen, differs(mittagessen, daten.MenueWahl.map(e => e.WAHL)))
            const MenueWahl = {
                User: user.username,
                FirstDate: (new Date(daten.MenueWahl[0]['DATUM'])).toISOString(),
                MenueWahl: mittagessen,
                Fruehstueck: fruehstueck,
                Abendessen: abendessen,
                ToGo: togo,
                Sonstiges: sonstiges
            };
            //const { fn, key } = 
            s3WriteFile('MenueWahl.txt', MenueWahl, "private", "text/plain");
            // console.log('handleSaveButton: different', e.target, MenueWahl)
            // console.log('file written', fn, key);
            storeMenueWahl(MenueWahl);
        }
        setSticky(false);
        setSaved(setTimeout(() => {
            setSaved(null);
        }, 1000))
    }

    useEffect(() => {

        if (!menues) {
            s3ReadFile('MenueTables.json', 'public', storeMenues);
        }

        if (!daten || daten.length === undefined || daten.length < 1) {
            // console.log('useEffect no daten')
            s3ListObjects('', 'private', handleS3MenueWahl);
        }
        return () => {
            if (saved != null) {
                clearTimeout(saved);
                setSaved(null);
            }
        }
        // console.log('useEffect called in Menues... isLoaded', daten, speiseplan, isLoaded)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // console.log('--> Menues... isLoaded=%s, values', isLoaded, menues)
    // console.log('--> Daten... isLoaded=%s, values', isLoaded, daten)
    // console.log('Start-Date is:', values[0]['DATUM_VON'])

    // style={{ position: "sticky", top: 100, display: "flex", justifyContent: "flex-end" }}

    if (!user) {
        return (<Navigate to='/profile' replace={true} />)
    }

    /*
        if (!daten || daten.length  === undefined || daten.length === 0) {
            return null;
        }
    */
    // console.log('neu befüllte MenueWahlListe:', daten)
    return (
        <Container fluid style={{
            backgroundImage: `url(${background})`,
        }}>
            {!menues && <Loading loadingtext="Menüs" />}
            {!daten && <Loading loadingtext="Speiseplan" />}
            {menues && daten &&
                <>
                    <form onSubmit={handleSaveButton}>
                        <div
                            className="floating-div"
                            style={{
                                position: "fixed",
                                right: "10px",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "0.5rem",
                                padding: "1rem",
                                zIndex: "50"
                            }}>
                            <Button style={{ backgroundColor: 'white'}} variant="light" onClick={handleShow}>Hilfe</Button>
                            {sticky &&
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                    variation="primary"
                                > <MdSave />&nbsp;Speichern</Button>
                            }
                            {saved && <Button
                                size='large'
                                gap="1rem"
                                variation="primary"
                            > <MdDoneOutline />&nbsp;gespeichert</Button>
                            }
                        </div>
                        <Offcanvas show={show} onHide={handleClose}>
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Erläuterungen</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <p>Sie können für jeden Tag ein Menü auswählen, indem Sie auf den Namen des Menüs klicken.</p>
                                {istMitarbeiter(user) ?
                                    <p>Aus den wählbaren Beilagen können Sie sich eine aussuchen oder leer lassen (Es macht wenig Sinn zu einem Kartoffeleintopf mit Brötchen noch Salzkartoffeln zu wählen).</p>
                                    :
                                    <>
                                        <p>Am Tag Ihrer Ankunft erhalten Sie ein Menü, das unser Küchenchef für den Anreisetag vorbereitet hat.</p>
                                        <p>Sie können ab dem nächsten Tag nach Ihrer Ankunft das jeweils gewünschte Menü aus unserer Auswahl bestellen.</p>
                                        <p>Das Menü mit dem 'goldenen Sternchen' ist die Empfehlung der Küche; dieses Menü bekommen Sie wenn Sie nichts wählen.</p>
                                        <p>Zu jedem Menü können Sie sich dann direkt bei der Ausgabe eine der wählbaren Beilagen auswählen.</p>
                                    </>
                                }
                                <p>Nach einer Änderung erscheint unten das Feld "Speichern"; vergessen Sie bitte nicht Ihre Auswahl durch anklicken zu speichern.</p>
                                <p>KE (Kohlehydrateinheiten) und kCal (Kilokalorien) eines Menüs werden angezeigt, wenn Sie das Feld unter dem Namen des Menüs anklicken. Bei den wählbaren Beilagen wird die KE und kCal der Beilage separat angezeigt.</p>
                                <p></p>
                                <p>Die gespeicherten Änderungen werden einmal nachts übernommen, weshalb es auch nicht möglich ist, Änderungen für den gleichen Tag vorzunehmen.</p>
                            </Offcanvas.Body>
                        </Offcanvas>
                        <Alert variation="info" isDismissible={true}>Das Menü mit dem 'goldenen Sternchen' <Empfehlung>&nbsp;</Empfehlung> ist die Empfehlung der Küche für eine abwechslungsreiche und ausgewogene Ernährung.<br />Alle unsere Speisen können technologisch unvermeidbare Spuren von Soja, Sellerie, Gluten, Krebstieren, Ei, Fisch, Haselnuss, Soja, Milch, Sellerie, Senf, Sesam und Farbstoff enthalten.</Alert>
                        <p></p>
                        <MenueList
                            onChange={handleChange}
                            startDatum={startDatum}
                            key='dummy'
                        />
                        {sticky && showFooter &&
                            <Footer>
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                ><MdSave />Speichern</Button>
                            </Footer>
                        }
                    </form>
                </>
            }
        </Container>
    )
}

export default Menues;